<form [formGroup]="profileForm" (ngSubmit)="onSubmit()">
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">Edit Profile <span class="nav-thai-font">แก้ไขข้อมูลส่วนตัว</span></h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="dismissModal()"></button>
  </div>
  <div class="modal-body">
    <div class="row">
      <div class="col-md-6">
        <label class="textColor label-inline topic-to-left" for="ep-first-name">First name<br /><span
            class="nav-thai-font">ชื่อ</span></label>
        <input id="ep-first-name" type="text" class="form-control mb-4" formControlName="first_name"
          placeholder="First name" />
      </div>

      <div class="col-md-6">
        <label class="textColor label-inline topic-to-left" for="ep-last-name">Last name<br /><span
            class="nav-thai-font">นามสกุล</span></label>
        <input id="ep-last-name" type="text" class="form-control mb-4" formControlName="last_name"
          placeholder="Last name" />
      </div>

      <div class="col-md-6">
        <label class="textColor label-inline topic-to-left" for="ep-email">E-mail<br /><span
            class="nav-thai-font">อีเมล</span></label>
        <input id="ep-email" type="email" class="form-control mb-4" formControlName="email" placeholder="E-mail" />
      </div>

      <div class="col-md-6">
        <label class="textColor label-inline topic-to-left" for="ep-phone">Phone number<br /><span
            class="nav-thai-font">เบอร์โทร</span></label>
        <input id="ep-phone" type="tel" autocomplete="off" class="form-control mb-4" formControlName="phone_number"
          placeholder="Phone number" />
      </div>

      <div class="col-md-12">
        <label class="textColor label-inline topic-to-left" for="ep-company">Company<br /><span
            class="nav-thai-font">บริษัท</span></label>
        <input id="ep-company" type="text" class="form-control mb-4" formControlName="company_name"
          placeholder="Company" />
      </div>

      <div class="col-md-12">
        <label class="textColor label-inline topic-to-left" for="ep-address">Address<br /><span
            class="nav-thai-font">ที่อยู่</span></label>
        <textarea id="ep-address" class="form-control mb-4" formControlName="company_address" rows="3"></textarea>
      </div>

      <div class="col-md-12">
        <label class="textColor topic-to-left" for="ep-password">New Password<br /><span
            class="nav-thai-font">รหัสผ่านใหม่ (เว้นว่างหากไม่ต้องการเปลี่ยน)</span></label>
        <div class="auth-input-wrap">
          <input id="ep-password" [type]="isHidePass ? 'password' : 'text'" class="form-control mb-4"
            formControlName="password" placeholder="New Password" autocomplete="new-password" />
          <i class="fa auth-eye-icon cursor__point" [ngClass]="isHidePass ? 'fa-eye' : 'fa-eye-slash'"
            (click)="isShow()" role="button" [attr.aria-label]="isHidePass ? 'Show password' : 'Hide password'"
            tabindex="0" (keydown.enter)="isShow()"></i>
        </div>
      </div>
    </div>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-outline-secondary" (click)="dismissModal()">Cancel</button>
    <button type="submit" class="btn btn-primary" [disabled]="profileForm.invalid || isSaving">
      @if (isSaving) {
      <span class="spinner-border spinner-border-sm me-2" aria-hidden="true"></span>
      <span class="visually-hidden">Saving…</span>
      }
      Save
    </button>
  </div>
</form>
